/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import { arrayMove } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';
import { v4 as uuidv4 } from 'uuid';

const axiosPayLoad = {
  generateInvoiceTabObj: {},
  perviousSearchScreenDataRedux: {},
  errorMessagesInRedux: [],
  quarter: '',
  planTypeRadioList: [],
  dropdown: [],
  generateInvoiceGridVOList: [],
  generateInvDetailTabObj: {},
  customizeLetterMsg: '',
  planTypeCd: '',
  saveFailedInvoice: {},
};
let tempObj = [];
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_PLAN_TYPE_DATA_G_INV:
      // eslint-disable-next-line vars-on-top, no-var
      var updatedArray = [];
      // eslint-disable-next-line vars-on-top, no-var
      var localAr = action.planTypeRadioList;
      if (localAr?.PLAN_TYPE_CD?.length > 0) {
        const planArray = localAr?.PLAN_TYPE_CD;
        planArray.forEach((element) => {
          if (element?.codeValueID?.codeValue === 'FD') {
            const indexOf = _.findIndex(planArray, element);
            if (!_.isNull(indexOf) && indexOf >= 0) {
              updatedArray = arrayMove(localAr?.PLAN_TYPE_CD, indexOf, 0);
            }
            localAr.PLAN_TYPE_CD = updatedArray;
          }
        });
      }
      return { ...state, planTypeRadioList: localAr };

    case actionTypes.GENERATE_INVOICE_SEARCH_TAB_DATA:
      return { ...state, generateInvoiceTabObj: action.generateInvoiceTabObj };
    case actionTypes.PERV_SEARCH_SCREEN_DATA:
      return {
        ...state,
        perviousSearchScreenDataRedux: action.perviousSearchScreenDataRedux,
      };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_G_INV:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.GET_COMMON_DROPDOWN_DATA_G_INV:
      return { ...state, dropdown: action.dropdown };
    case actionTypes.GET_QUARTER_DATA_G_INV:
      return { ...state, quarter: action.quarter };
    case actionTypes.GET_SEARCH_G_INV_BY_CRITERIA:
      if (action.generateInvoiceGridVOList?.length > 0) {
        tempObj = action.generateInvoiceGridVOList?.map((item) => {
          if (item.sortKey) item.cfSortKey = item.sortKey;
          item.id = uuidv4();
          item.defPaperInd = item.defPaperInd ? item.defPaperInd : 0;
          item.printImageInd = item.printImageInd ? item.printImageInd : 0;
          item.defCmsElectInd = item.defCmsElectInd ? item.defCmsElectInd : 0;
          item.defNcpdpSummaryInd = item.defNcpdpSummaryInd
            ? item.defNcpdpSummaryInd
            : 0;
          item.defNcpdpClaimMbInd = item.defNcpdpClaimMbInd
            ? item.defNcpdpClaimMbInd
            : 0;
          item.defNcpdpClaimOwnInd = item.defNcpdpClaimOwnInd
            ? item.defNcpdpClaimOwnInd
            : 0;
          return item;
        });
      } else {
        tempObj = [];
      }
      return { ...state, generateInvoiceGridVOList: tempObj };
    case actionTypes.GENERATE_INVOICE_DETAIL_TAB_DATA:
      return {
        ...state,
        generateInvDetailTabObj: action.generateInvDetailTabObj,
      };
    case actionTypes.GET_RUN_NOW_GI:
      return { ...state, runApiResult: action.runApiResult };
    case actionTypes.PDF_RUN_NOW_GI:
      return { ...state, pdfPrev: action.pdfPrev };
    case actionTypes.UPDATE_CUSTOMIZE_LETTER:
      return { ...state, customizeLetterMsg: action.customizeLetterMsg };
    case actionTypes.GET_PLAN_TYPE_USING_REBATE_PROG:
      return { ...state, planTypeCd: action.planTypeCd };
    case actionTypes.SAVE_FAILED_INVOICES:
      return { ...state, saveFailedInvoice: action.saveFailedInvoice };
    default:
      return state;
  }
};

export default reducer;
